import { Col, Row } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';

import SettingsField from '../../settings-field';
import { INCOMING_ENCRYPTION_OPTIONS } from '../../../helpers';

const ImapHostFields = ({
    t,
    isFetching,
    defaultSettings,
    required,
}) => {
    const requiredRule = {
        required: {
            value: !!required,
            errorMessage: t('This field cannot be blank'),
        },
    };

    return (
        <Row>
            <Col sm="12" md="6" className="mb-3">
                <SettingsField
                    id="incomingServer"
                    label={t('IMAP Server')}
                    required={required}
                    isFetching={isFetching}
                    info={t('Incoming mail server used to sync Inbox, Sent and Trash.')}
                >
                    <AvField
                        id="incomingServer"
                        name="incomingServer"
                        type="text"
                        className="form-control"
                        validate={requiredRule}
                        value={defaultSettings?.incomingServer || ''}
                    />
                </SettingsField>
            </Col>

            <Col sm="12" md="6" className="mb-3">
                <SettingsField
                    id="incomingPort"
                    label={t('IMAP Port')}
                    required={required}
                    isFetching={isFetching}
                >
                    <AvField
                        id="incomingPort"
                        name="incomingPort"
                        type="number"
                        className="form-control"
                        validate={requiredRule}
                        value={defaultSettings?.incomingPort || ''}
                    />
                </SettingsField>
            </Col>

            <Col sm="12" md="6" className="mb-3">
                <SettingsField
                    id="incomingEncryption"
                    label={t('IMAP Encryption')}
                    required={required}
                    isFetching={isFetching}
                    info={t('Use SSL for port 993 in most cases. Values are sent in uppercase.')}
                >
                    <AvField
                        id="incomingEncryption"
                        name="incomingEncryption"
                        type="select"
                        className="form-control"
                        validate={requiredRule}
                        value={(defaultSettings?.incomingEncryption || 'SSL').toString().toUpperCase()}
                    >
                        {INCOMING_ENCRYPTION_OPTIONS.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </AvField>
                </SettingsField>
            </Col>

            <Col sm="12" md="6">
                <SettingsField
                    id="incomingUsername"
                    label={t('IMAP Username')}
                    isFetching={isFetching}
                    info={t('Usually the same as the mailbox email address. Leave blank to use the email address.')}
                >
                    <AvField
                        id="incomingUsername"
                        name="incomingUsername"
                        type="text"
                        className="form-control"
                        value={defaultSettings?.incomingUsername || ''}
                    />
                </SettingsField>
            </Col>
        </Row>
    );
};

export default ImapHostFields;
